import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";

import type { FC } from "react";

// Wrapped so DataGrid's slot props are not forwarded to the icons.
export const ExpandLessIcon: FC = () => <ExpandLess />;
export const ExpandMoreIcon: FC = () => <ExpandMore />;
